import { combineReducers } from '@reduxjs/toolkit';
import geoMap from './geoMapSlice';
import projections from './projectionsSlice';
import createScenario from './createScenarioSlice';
import sidePanel from './sidePanelSlice';
import service from './serviceSlice';
import redirectButton from './redirectButtonSlice';

const rootReducer = combineReducers({
    geoMap,
    projections,
    createScenario,
    service,
    sidePanel,
    redirectButton,
});

export type RootState = ReturnType<any>;

export default rootReducer;
